import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DepartmentModel } from 'src/app/core/models/DepartmentModel';
import { SubDepartmentModel } from 'src/app/core/models/SubDepartmentModel';
import { User } from 'src/app/core/models/user';
import { UserService } from 'src/app/core/services/user.service';
import { AdminService } from '../admin.service';
import { DbMasterService } from 'src/app/core/services/db-master.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Constants } from 'src/app/constants/constants';
import { DeactivateTypeEnum } from 'src/app/core/models/DeactivateTypeEnum';
import { ViewValidationsComponent } from '../view-validations/view-validations.component';

@Component({
  selector: 'app-sub-department',
  standalone: false,
  templateUrl: './sub-department.component.html',
  styleUrl: './sub-department.component.less'
})
export class SubDepartmentComponent {
  exportData: any[] = [];
  searchText: string = "";
  subDepartmentForm!: FormGroup;
  isVisible = false;
  isConfirmLoading = false;
  isEditMode = false;

  config: any;
  currentPageSize = 10;
  sortingName: string = "";
  isDesc: boolean = false;

  currentUser: User = new User();
  subDeptMaster: any = [];
  departmentMaster: DepartmentModel[] = [];
  suDeptToBeAdded = new SubDepartmentModel();

  subDeptSelected = new SubDepartmentModel();
  subDeptToBeEdited = new SubDepartmentModel();

  duplicateRecordMessge: string = "";
  openQueries = [];
  constructor(
    private router: Router,

    private userService: UserService,
    private adminService: AdminService,
    private messageService: NzMessageService,
    private modalService: NzModalService,
    private dbMasterService: DbMasterService,
    private fb: FormBuilder,
  ) { }
  ngOnInit() {
    this.currentUser = this.userService.getCurrentUser();
    if (this.currentUser?.User_Code == null) {
      window.location.href = '/';
    }
    if (this.currentUser.IsRFCAdmin) {
      this.initializeData();
      this.getAllSubDepartmentsMapping();
      this.getAllDepartments();
      this.initializeSubDepartmentForm();
    }
    else {
      this.router.navigate(['/unauthorize']);
    }
  }
  initializeData() {
    this.duplicateRecordMessge = '';

    this.config = {
      itemsPerPage: this.currentPageSize,
      currentPage: 1,
      totalItems: this.departmentMaster.length
    }
  }
  getAllSubDepartmentsMapping() {
    this.adminService.getAllSubDeptMapping().subscribe((response: any) => {
      this.subDeptMaster = response.output;
      this.subDeptMaster.forEach(function (element: any) {
        element.SubDeptStatus = element["Active"] ? "Active" : "Inactive";
        element.DeptStatus = element["Department_Active"] ? "Active" : "Inactive";
      });
      
    });
  }
  getAllDepartments(): void {
    this.adminService.getAllDepartments().subscribe((response: any) => {
      this.departmentMaster = response.output as DepartmentModel[];
    });
  }
  initializeSubDepartmentForm(): void {
    this.subDepartmentForm = this.fb.group({
      department: ['', Validators.required],
      subDepartmentName: ['', [Validators.required, Validators.maxLength(50)]],
      managerEmail: ['', [Validators.required, Validators.email]],
      supervisorEmail: ['', [Validators.required, Validators.email]]
    });
  }

  listOfColumn = [
    {
      title: 'Department',
      compare: (a: SubDepartmentModel, b: SubDepartmentModel) => (a.Department_Name || '').localeCompare(b.Department_Name || ''),
      priority: 3,
      allowSorting: true
    },
    {
      title: 'Department Status',
      compare: null,
      priority: 2,
      allowSorting: true
    },
    {
      title: 'Sub Department',
      compare: (a: SubDepartmentModel, b: SubDepartmentModel) => (a.Sub_Dept_Name || '').localeCompare(b.Sub_Dept_Name || ''),
      priority: 1,
      allowSorting: true
    }
    ,
    {
      title: 'Manager Email',
      compare: (a: SubDepartmentModel, b: SubDepartmentModel) => a.Manager_Email.localeCompare(b.Manager_Email || ''),
      priority: 1,
      allowSorting: true
    },
    {
      title: 'Supervisor Email',
      compare: (a: SubDepartmentModel, b: SubDepartmentModel) => (a.Supervisor_Email || '').localeCompare(b.Supervisor_Email || ''),
      priority: 1,
      allowSorting: true
    },
    {
      title: 'Status',
      compare: null,
      priority: 1,
      allowSorting: true
    },
    {
      title: 'Action',
      compare: null,
      priority: false,
      allowSorting: false
    }
  ];
  showCreateModal(): void {
    this.isEditMode = false;
    this.subDepartmentForm.reset();
    this.isVisible = true;
  }

  showEditModal(subDepartment: SubDepartmentModel): void {
    this.isEditMode = true;
    this.subDeptToBeEdited = Object.assign({}, subDepartment); // Create a copy of the selected sub-department
    this.subDepartmentForm.patchValue({
      department: subDepartment.Department_Code,
      subDepartmentName: subDepartment.Sub_Dept_Name,
      managerEmail: subDepartment.Manager_Email,
      supervisorEmail: subDepartment.Supervisor_Email
    });
    this.isVisible = true;
  }
  showDeactivateModal(subDepartment: SubDepartmentModel): void {
    
    this.subDeptSelected = Object.assign({}, subDepartment); // Create a copy of the selected sub-department
    this.modalService.confirm({
      nzTitle: 'Confirm !',
      nzContent: 'Are you sure, you want to <strong>deactivate </strong> the sub department - <span class="referanceNumber"> ' + subDepartment.Sub_Dept_Name + '</span>?',
      nzOkText: 'Yes',
      nzWidth: '500px',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzClosable: false,
      nzAutofocus: null,
      nzOnOk: () => this.deactivateSubDepartment(subDepartment),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }
  deactivateSubDepartment(department: SubDepartmentModel) {
    this.dbMasterService.GetActiveQueryReferenceNumber(DeactivateTypeEnum.SubDepartment, this.subDeptSelected.Sub_Dept_Code).subscribe((response: any) => {
      if (response.output.length == 0) {
        let selSubDept = new SubDepartmentModel();
        selSubDept.Department_Code = this.subDeptSelected.Department_Code;
        selSubDept.Sub_Dept_Code = this.subDeptSelected.Sub_Dept_Code;
        selSubDept.Created_By = this.currentUser.User_Code ?? 0;
        this.adminService.deleteSubDept(selSubDept).subscribe((response: any) => {
          if (response.result) {
            this.messageService.success(`Department ${department.Department_Name} deactivated successfully!`, { nzDuration: Constants.SHOW_MESSAGE_DURATION });
            this.getAllSubDepartmentsMapping();
            this.resetModalPopup(); // Reset the form and messages
          }
          else {
            this.messageService.error("Only active Sub Department can be deactivated");
          }
          this.resetToDefault();
        });
      }
      else {
        this.openQueries = response.output as [];
        this.viewValidationMsg();
      }
    })
    return false;
  }
  handleOk(): void {
    if (this.subDepartmentForm.valid) {
      this.isConfirmLoading = true;
      const formValue = this.subDepartmentForm.value;

      if (this.isEditMode) {
        this.subDeptToBeEdited.Department_Code = formValue.department;
        this.subDeptToBeEdited.Sub_Dept_Name = formValue.subDepartmentName;
        this.subDeptToBeEdited.Manager_Email = formValue.managerEmail;
        this.subDeptToBeEdited.Supervisor_Email = formValue.supervisorEmail;
        this.updateSubDepartment();
      } else {
        this.suDeptToBeAdded.Department_Code = formValue.department;
        this.suDeptToBeAdded.Sub_Dept_Name = formValue.subDepartmentName;
        this.suDeptToBeAdded.Manager_Email = formValue.managerEmail;
        this.suDeptToBeAdded.Supervisor_Email = formValue.supervisorEmail;
        this.addSubDepartment();
      }
    }
  }
  handleCancel(): void {
    this.isVisible = false;
    this.subDepartmentForm.reset();
    this.isEditMode = false;
    this.resetModalPopup(); // Reset the form and messages
  }
  addSubDepartment() {
    var record = this.subDeptMaster.filter((s: SubDepartmentModel) => s.Department_Code == this.suDeptToBeAdded.Department_Code && s.Sub_Dept_Name.toLowerCase().trim() == this.suDeptToBeAdded.Sub_Dept_Name.toLowerCase().trim());
    if (record.length > 0) {
      this.duplicateRecordMessge = 'Sub Department Name already exist in the Department';
    }
    else {
      this.suDeptToBeAdded.Created_By = this.currentUser.User_Code ?? 0;
      this.adminService.addSubDept(this.suDeptToBeAdded).subscribe((response: any) => {
        if (response.result) {
          
          this.messageService.success(`Department ${this.suDeptToBeAdded.Department_Name} created successfully!`, { nzDuration: Constants.SHOW_MESSAGE_DURATION });
          this.getAllSubDepartmentsMapping();
          this.resetModalPopup(); // Reset the form and messages
        }
        else {                    
          this.messageService.error("Sub Department name already exist for the selected department");
        }
      });
      this.resetToDefault();
    }
  }
  resetToDefault() {
    this.subDeptSelected = this.subDeptToBeEdited = this.suDeptToBeAdded = new SubDepartmentModel();
    this.duplicateRecordMessge = "";
  }
  isDuplicateSubDepartment(): boolean {
    return this.subDeptMaster.some((subDept: SubDepartmentModel) =>
      subDept.Department_Code === this.subDeptToBeEdited.Department_Code &&
      subDept.Sub_Dept_Name.toLowerCase().trim() === this.subDeptToBeEdited.Sub_Dept_Name.toLowerCase().trim() &&
      (!this.subDeptToBeEdited.Sub_Dept_Code || subDept.Sub_Dept_Code !== this.subDeptToBeEdited.Sub_Dept_Code)
    );
  }
  updateSubDepartment() {
    this.duplicateRecordMessge = '';
    // var record = this.subDeptMaster.filter((s: SubDepartmentModel) => s.Department_Code == this.subDeptToBeEdited.Department_Code
    //       && (s.Sub_Dept_Code != this.subDeptToBeEdited.Sub_Dept_Code && s.Sub_Dept_Name.toLowerCase().trim() == this.subDeptToBeEdited.Sub_Dept_Name.toLowerCase().trim())
    //       || (s.Sub_Dept_Code == this.subDeptToBeEdited.Sub_Dept_Code && s.Sub_Dept_Name.trim() == this.subDeptToBeEdited.Sub_Dept_Name.trim())
    //               && s.Manager_Email.toLowerCase().trim() == this.subDeptToBeEdited.Manager_Email.toLowerCase().trim()
    //               && s.Supervisor_Email.toLowerCase().trim() == this.subDeptToBeEdited.Supervisor_Email.toLowerCase().trim()
    //       );
    // if (record.length > 0) {
    if (this.isDuplicateSubDepartment()) {
      this.duplicateRecordMessge = 'Sub Department Name already exist in the Department';
      this.isConfirmLoading = false; // Hide loading spinner
    }
    else {
      this.subDeptToBeEdited.Created_By = this.currentUser.User_Code ?? 0;
      this.adminService.updateSubDept(this.subDeptToBeEdited).subscribe((response: any) => {
        if (response.result) {
          this.messageService.success(`Sub Department details updated successfully!`, { nzDuration: Constants.SHOW_MESSAGE_DURATION });
          this.getAllSubDepartmentsMapping();
          this.resetModalPopup(); // Reset the form and messages
        }
        else {
          this.messageService.error("Only active Sub Department can be edited");
        }
      });
      this.resetToDefault();
    }
  }
  viewValidationMsg() {
    this.modalService.create({
      nzTitle: 'Validations',
      nzClosable: false,
      nzFooter: null,
      nzAutofocus: null,
      nzContent: ViewValidationsComponent,
      nzData: {
        validationText: 'Please respond to the open queries and then only deactivate <b>Sub Department</b>.',
        openQueries: this.openQueries
      },
    });
  }
  resetModalPopup() {
    this.resetToDefault(); // Reset the form and messages
    this.isVisible = false; // Hide the modal
    this.isEditMode = false; // Reset to create mode
    this.isConfirmLoading = false; // Hide loading spinner
    this.modalService.closeAll(); // Close any open modals
  }
}
